import { combineReducers } from "redux";
import { reducer as reduxFormReducer } from "redux-form";

export const forms = combineReducers({
    loginForm: reduxFormReducer,
    recoverForm: reduxFormReducer,
    createForm: reduxFormReducer,
    setExistingClientCredentialsForm: reduxFormReducer,
});
